import { type JSX } from 'react/jsx-runtime';

import { createRender, type HydrationResult } from './types';

import { JiraTwgCtaMessage } from '../../../common/components/JiraTwgCtaMessage';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(({ onDismissed }) => {
	return (
		<JiraTwgCtaMessage
			handleOnDismissed={onDismissed}
			context={{
				source: 'jira-side-nav',
			}}
		/>
	);
});

export default render;
